import { Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'chat-avatar',
  encapsulation: ViewEncapsulation.None,
  template: `
    <img *ngIf="image != '' " [attr.src]="image" class="avatar" />
    <ngx-avatar class="avatar"  *ngIf="image == '' && nome != '' " [size]=size [gravatarId]="nome"  [name]="nome"></ngx-avatar>
  `,
  styles: [`
    .avatar {
      height: 30px;
      width: 30px ;
      border-radius: 50%;
      float: left;
      margin-right: 10px;
      border:0.5px solid #c9d1d7; 
      background: white;
    }
  `]
})
export class ChatAvatarComponent {
  @Input() public image: string
  @Input() public nome: string
  @Input() public size: number
}
